import type { Flow, FlowMetadata } from '../models/types'

export default function getJs(
  flow: Flow,
  groupId: string,
  metadata: FlowMetadata | {},
  userData: Record<string, unknown>
) {
  if (!metadata) metadata = {}
  const pageTitle = `Embeddables${
    metadata && 'title' in metadata
      ? ': ' + metadata?.title
      : flow.name
      ? ': ' + flow.name
      : flow.title
      ? ': ' + flow.title
      : ''
  }`

  return `
    function ({ element }) {
      const urlParams = new URLSearchParams(window.location.search)
      const flowId = urlParams.get('id') || window.location.pathname.split("/").pop()
      const breakpoints = [${[520, 720]
        .concat((flow.breakpoints || []).map((b) => b.max_width))
        .toString()}]
      const entireFlowEl = element.querySelector('.Flow-EntireFlow')
      const currentBreakpointGroups = breakpoints.filter((b) => entireFlowEl.offsetWidth <= b)
      const attrValue = currentBreakpointGroups.map((b) => \`\${b}px\`).join(' ')
      entireFlowEl.setAttribute('max-width', attrValue)

      const editingHostnames = ['edit.embeddables.com']
      const editingUrlRegexes = [
        /^https?:\\/\\/app\\.embeddables\\.com\\/edit\\/.*(\\?.*)?$/,
        /^https?:\\/\\/old\\.embeddables\\.com\\/edit\\/.*(\\?.*)?$/,
        /^https?:\\/\\/radar\\.embeddables\\.com\\/edit\\/.*(\\?.*)?$/,
        /^https?:\\/\\/build\\.embeddables\\.com\\/edit\\/.*(\\?.*)?$/,
        /^https?:\\/\\/embeddables-.+\\.vercel\\.app\\/edit\\/.*(\\?.*)?$/,
      ]

      if (window.location.host.endsWith('trysavvy.com') || window.location.hostname === 'preview.embeddables.com' || window.location.href.includes('app.embeddables.com/edit') || window.location.host.endsWith('cidemo.co') || window.location.host === 'localhost:9000') {
        if(flowId==='${flow.id}') document.title = '${pageTitle.replaceAll("'", "\\'")}'
      } 

      // Create savvy-global element with data-controller="global"
      if (!document.querySelector('savvy-global')) {
        const savvyGlobal = document.createElement('savvy-global')
        savvyGlobal.setAttribute('data-controller', 'global')
        document.body.appendChild(savvyGlobal)
      }
      
      // Create savvy-editor element with data-controller="global-edit"
      const isEditingMode = (urlParams.get('savvy_editing') || editingHostnames.includes(window.location.hostname) || editingUrlRegexes.some((regex) => regex.test(window.location.href)))
      if (isEditingMode && !document.querySelector('savvy-editor')) {
        // Create savvy-editor element with data-controller="global-edit"
        const savvyEditor = document.createElement('savvy-editor')
        savvyEditor.setAttribute('data-controller', 'global-edit')
        document.body.appendChild(savvyEditor)
      }

      if (!window.Savvy) window.Savvy = {}
      if (!window.Savvy.group_id) window.Savvy.group_id = '${groupId}'
      if (!window.Savvy.project_id) window.Savvy.project_id = ${
        (metadata as FlowMetadata).project_id
          ? `'${(metadata as FlowMetadata).project_id}'`
          : 'null'
      }
      
      if (!window.Savvy.flow_metadata) window.Savvy.flow_metadata = {}
      if (!window.Savvy.flow_metadata['${flow.id}']) window.Savvy.flow_metadata['${
    flow.id
  }'] = ${JSON.stringify({ ...metadata, flow_id: (metadata as FlowMetadata).id })}
  
      //* Here we merge all the user data (1° defaults, 2° local storage, 3° handleRequest data) and update the local storage
      let userData = ${JSON.stringify(flow.defaults?.userData || {})} || {}
      
      const localStorageAllUserData = JSON.parse(localStorage.getItem('SavvyFormUserData') || '{}')
      const localStorageUserData = localStorageAllUserData['${flow.id}'] || {}
      userData = { ...userData, ...localStorageUserData }
      
      const userDataFromHandleRequestWithoutDefaults = ${JSON.stringify(userData)} || {}
      userData = { ...userData, ...userDataFromHandleRequestWithoutDefaults }

      localStorageAllUserData['${flow.id}'] = userData
      localStorage.setItem('SavvyFormUserData', JSON.stringify(localStorageAllUserData))

      // Get all the savvy elements in the DOM and add Embeddables comments to them
      const scriptElements = document.querySelectorAll("script");
      scriptElements?.forEach(script => {
        if (script.textContent.includes("getBundleSrc") && script.previousSibling?.nodeType!==Node.COMMENT_NODE && !script.previousSibling?.textContent?.includes("Embeddables")) {
          const startComment = document.createComment("START: Embeddables (formerly Savvy) Script - https://embeddables.com");
          const endComment = document.createComment("END: Embeddables (formerly Savvy) Script - https://embeddables.com");
          script.parentNode.insertBefore(startComment, script);
          script.parentNode.insertBefore(endComment, script.nextSibling);
        }
      });

      // Get all the <savvy> and <savvy-global> elements in the DOM and add comments to them
      const savvyElements = document.querySelectorAll("savvy, savvy-global");

      if(!isEditingMode) {
        console.log('%cThis page was built using Embeddables', 'font-size: 14px; font-weight:500;font-family: "Consolas", sans-serif; text-shadow: 1px 1px 0px rgba(0,0,0,0.6);text-decoration: none;  background-color: #7144F2; color: #F7F5ED; padding:6px 18px; border-radius: 5px; box-shadow: 10px 10px 0px 3px rgba(0,0,0,0.75);');
        console.log('%c➡  https://embeddables.com', 'font-size: 14px; font-weight:500;font-family: "Consolas", sans-serif; text-decoration: none; padding:6px 0px; border-radius: 5px; box-shadow: 10px 10px 0px 3px rgba(0,0,0,0.75);');
      }

      savvyElements?.forEach(element => {
        if (element.previousSibling?.nodeType===Node.COMMENT_NODE && element.previousSibling?.textContent?.includes("Embeddables")) return;
        const startComment = document.createComment("START: Embeddables (formerly Savvy) Embed Code - https://embeddables.com");
        const endComment = document.createComment("END: Embeddables (formerly Savvy) Embed Code - https://embeddables.com");
        element.parentNode.insertBefore(startComment, element);
        element.parentNode.insertBefore(endComment, element.nextSibling);
      });
    }
  `
}
